{
  "behaviorSummaryCard": {
    "ronLikelihood": {
      "label": "Probabilidad de RON",
      "tooltip": "Probabilidad de que esta aeronave pernocte"
    },
    "typicalArrival": {
      "label": "Llegada típica",
      "tooltip": "Hora de llegada más frecuente de esta aeronave"
    },
    "typicalTurn": {
      "label": "Rotación típica",
      "tooltip": "Tiempo promedio en tierra entre llegada y salida",
      "tooltipDetail": "Basado en datos históricos de vuelos"
    },
    "visitTypes": {
      "quickTurn": "Rotación rápida",
      "dayStop": "Escala día",
      "ron": "RON"
    },
    "basedOn": "Basado en",
    "title": "Resumen de comportamiento"
  },
  "filters": {
    "flightTypes": {
      "all": "Todo",
      "arrivals": "Llegadas",
      "departures": "Salidas"
    },
    "statuses": {
      "scheduled": "Programado",
      "active": "Activo",
      "landed": "Aterrizó",
      "cancelled": "Cancelado"
    },
    "flags": {
      "vipOnly": "Solo VIP",
      "favoritesOnly": "Solo favoritos",
      "showIgnored": "Mostrar ignorados"
    },
    "search": {
      "placeholder": "Buscar vuelos..."
    },
    "lastUpdated": {
      "neverUpdated": "Nunca actualizado",
      "justNow": "Ahora",
      "minutesAgo": "Hace minutos",
      "secondsAgo": "Hace segundos"
    },
    "dropdowns": {
      "allStatus": "Todo estado",
      "flags": "Marcas",
      "operator": "Operador"
    },
    "myReservations": "Mis reservaciones",
    "liveStatus": "EN VIVO",
    "arrivingSoon": "Llegando pronto"
  },
  "services": {
    "fuel": "Comb.",
    "hangar": "Hangar",
    "catering": "Catering",
    "hotel": "Hotel",
    "crewCar": "Auto crew",
    "limo": "Limo",
    "carRental": "Renta de auto",
    "arrivalLimo": "Limo de llegada",
    "departureLimo": "Limusina de salida",
    "deicing": "Deshielo",
    "groundPower": "Energía de tierra",
    "gpu": "GPU",
    "lavatory": "Sanitario",
    "lavService": "Servicio lav",
    "water": "Agua",
    "towing": "Remolque",
    "oxygen": "Oxígeno",
    "conferenceRoom": "Sala de conferencias",
    "customs": "Aduana",
    "cipService": "Servicio CIP",
    "payment": "Pago",
    "dishes": "Platos",
    "linens": "Sábanas",
    "otherArrival": "Otro (Llegada)",
    "otherDeparture": "Otro (Salida)"
  },
  "flightRow": {
    "tooltips": {
      "hasReservation": "Tiene reservación"
    }
  },
  "flightNotes": {
    "defaultTags": {
      "ops": "Ops",
      "fuel": "Comb.",
      "catering": "Catering",
      "hotel": "Hotel",
      "crew": "Crew",
      "vipRequest": "Solicitud VIP",
      "followUp": "Seguimiento",
      "urgent": "Urgente"
    },
    "search": {
      "placeholder": "Buscar notas...",
      "clearSearch": "Borrar búsqueda",
      "noMatches": "Sin resultados"
    },
    "emptyState": {
      "title": "Sin notas aún",
      "message": "Usa notas para coordinar con tu equipo sobre este vuelo",
      "quickActions": {
        "passengersArrived": {
          "label": "Pasajeros llegados",
          "template": "Pasajeros han llegado",
          "tag": "Ops"
        },
        "fuelCompleted": {
          "label": "Carga completada",
          "template": "Combustible completado",
          "tag": "Comb."
        },
        "crewCalled": {
          "label": "Crew avisada",
          "template": "El equipo ha sido notificado",
          "tag": "Crew"
        },
        "ownerRequest": {
          "label": "Solicitud propiet.",
          "template": "Solicitado por dueño:",
          "tag": "Solicitud VIP"
        }
      }
    },
    "dateLabels": {
      "today": "Hoy",
      "yesterday": "Ayer"
    },
    "composer": {
      "placeholder": "Añadir nota...",
      "quickTags": "Tags rápidos",
      "helpText": "Presiona Enter para enviar, Shift+Enter para nueva línea"
    },
    "noteActions": {
      "edited": "editado",
      "cancel": "Cancelar"
    },
    "messages": {
      "loadFailed": "Error al cargar notas",
      "notePinned": "Nota fijada",
      "noteUnpinned": "Nota desanclada",
      "updateFailed": "Error al actualizar la nota",
      "noteUpdated": "Nota actualizada",
      "noteDeleted": "Nota eliminada",
      "deleteFailed": "No se pudo eliminar la nota",
      "noteCopied": "Nota copiada al portapapeles",
      "copyFailed": "Error al copiar la nota"
    },
    "confirmations": {
      "deleteNote": "¿Eliminar esta nota? Esta acción no se puede deshacer."
    }
  },
  "flightList": {
    "emptyState": {
      "noFlightsFound": "No se encontraron vuelos",
      "tryAdjustingFilters": "Intenta ajustar tus filtros"
    }
  },
  "notesDialog": {
    "labels": {
      "vip": "VIP"
    }
  },
  "opsCenterLoading": {
    "logoAlt": "Logo de AirPlx",
    "messages": {
      "fetchingOperations": "Cargando operaciones...",
      "syncingFlightAware": "Sincronizando con FlightAware...",
      "loadingPositions": "Cargando posiciones...",
      "updatingArrivals": "Actualizando llegadas...",
      "checkingDepartures": "Verificando salidas...",
      "pullingTracking": "Obteniendo datos de seguimiento..."
    }
  },
  "tailDetailDrawer": {
    "overallTendencies": {
      "title": "Tendencias generales",
      "lastDays": "Últimos días",
      "subtitle": "Subtítulo"
    },
    "estimatedFuel": {
      "label": "Combustible estimado",
      "tooltip": "Necesidades de combustible estimadas según tipo de aeronave y distancia típica del vuelo",
      "low": "Bajo",
      "high": "Alto"
    },
    "flightsPerDay": {
      "label": "Vuelos/Día",
      "tooltip": "Actividad de vuelo promedio para esta aeronave",
      "tooltipDetail": "Comparado con tipos de aeronave similares",
      "busier": "Más uso",
      "quieter": "Menor actividad"
    },
    "medianStay": {
      "label": "Estadía promedio",
      "tooltip": "Duración típica de esta aeronave en su FBO",
      "tooltipDetail": "Basado en visitas anteriores",
      "shorter": "Más corto",
      "longer": "Más largo"
    },
    "ronPercentage": {
      "label": "RON %",
      "tooltip": "Porcentaje de visitas que incluyen pernocta",
      "tooltipDetail": "Porcentaje de pernocta",
      "quick": "Rotaciones rápidas",
      "overnight": "Pernocta"
    },
    "recentFlights": {
      "noFlights": "Sin vuelos recientes",
      "tableHeaders": {
        "date": "Fecha",
        "route": "Ruta",
        "times": "Horas",
        "stay": "Estadía",
        "duration": "Duración",
        "status": "Estado"
      },
      "lastDays": "Últimos días",
      "title": "Vuelos recientes"
    },
    "prediction": {
      "atAirport": "En aeropuerto",
      "basedOn": "Basado en",
      "confidence": "Confianza"
    }
  },
  "tvFooter": {
    "justNow": "Ahora",
    "never": "Nunca",
    "hoursAgo": "Hace horas",
    "minutesAgo": "Hace minutos",
    "secondsAgo": "Hace segundos",
    "updated": "Actualiz."
  },
  "tvHeader": {
    "live": "VIVO",
    "autoScroll": "Auto desplazar",
    "exitTVMode": "Salir del modo TV",
    "switchToDarkMode": "Cambiar a modo oscuro",
    "switchToLightMode": "Cambiar a modo claro",
    "lastUpdated": "Últ. actualización"
  },
  "tvModeButton": {
    "tooltip": "Abrir en modo TV",
    "dialogTitle": "Modo TV",
    "tvModeLink": "Enlace de modo TV",
    "helperText": "Abre este enlace en una pantalla para mostrar el tablero de vuelos",
    "activeFilters": "Filtros activos",
    "noFilters": "Sin filtros activos",
    "filterLabels": {
      "arrivals": "Solo llegadas",
      "departures": "Solo salidas",
      "vipOnly": "Solo VIP",
      "favoritesOnly": "Solo favoritos",
      "myReservations": "Mis reservaciones",
      "showIgnored": "Incluir ignorados",
      "search": "Buscar",
      "status": "Estado",
      "type": "Tipo"
    },
    "buttons": {
      "copyLink": "Copiar enlace",
      "copied": "Copiado",
      "openInNewWindow": "Abrir en nueva ventana",
      "cancel": "Cancelar"
    }
  },
  "alertToast": {
    "relativeTime": {
      "hoursAgo": "Hace horas",
      "justNow": "Ahora",
      "minutesAgo": "Hace minutos",
      "oneHourAgo": "Hace una hora",
      "oneMinuteAgo": "Hace un minuto"
    },
    "unknownAircraft": "Aeronave desconocida"
  },
  "dashboard": {
    "errors": {
      "failedToLoadFlights": "Error: No se pudieron cargar los vuelos"
    }
  },
  "dataCoverageIndicator": {
    "etaAvailable": "ETA disponible",
    "liveTracking": "Seguimiento en vivo",
    "noETA": "Sin ETA",
    "noLiveData": "Sin datos en vivo",
    "operatorKnown": "Operador conocido",
    "unknownOperator": "Operador desconocido"
  },
  "flightDetailDrawer": {
    "altitudeStates": {
      "climbing": "Ascendiendo",
      "descending": "Descendiendo",
      "level": "Nivel"
    },
    "buttons": {
      "cancel": "Cancelar",
      "save": "Guardar"
    },
    "fields": {
      "actualIn": "Entrada real:",
      "actualOut": "Salida real:",
      "airport": "Aeropuerto:",
      "altitude": "Altitud:",
      "altitudeChange": "Cambio de altitud:",
      "assignedRampSpot": "Plataforma asignada:",
      "atcCallsign": "Indicativo ATC:",
      "code": "Código:",
      "delay": "Retraso:",
      "estimatedIn": "Llegada estimada:",
      "estimatedOut": "Salida estimada:",
      "flightId": "Id de vuelo:",
      "fuelRequest": "Combustible:",
      "groundspeed": "Vel. terrestre:",
      "hangarRequested": "Hangar solicitado:",
      "heading": "Rumbo:",
      "iata": "Iata:",
      "lastUpdated": "Últ. actualización:",
      "makeModel": "Marca y modelo:",
      "position": "Posición:",
      "progress": "Progreso:",
      "registration": "Matrícula:",
      "scheduledIn": "Llegada programada:",
      "scheduledOut": "Salida programada:",
      "status": "Estado:",
      "terminalGate": "Puerta de terminal:",
      "type": "Tipo:"
    },
    "formats": {
      "delayMinutes": "Minutos de retraso",
      "gate": "Puerta",
      "terminal": "Terminal"
    },
    "noFlightSelected": "Sin vuelo seleccionado",
    "placeholders": {
      "fuel": "Comb.",
      "spot": "Spot"
    },
    "sections": {
      "aircraft": "Aeronave",
      "destination": "Destino",
      "flightInformation": "Información de vuelo",
      "internalNotes": "Notas internas",
      "livePosition": "Posición en vivo",
      "operations": "Operaciones",
      "operator": "Operador",
      "origin": "Origen"
    },
    "units": {
      "degrees": "Grados",
      "feet": "Pies",
      "knots": "Nudos"
    }
  },
  "opsMap": {
    "airport": {
      "code": "Código",
      "name": "Nombre"
    },
    "emptyState": "Estado vacío",
    "labels": {
      "eta": "ETA",
      "etd": "ETD",
      "from": "Desde"
    }
  },
  "otherServicesPopover": {
    "title": "Otros servicios"
  }
}
